import { dispatchTrackingEvent } from '@context/tracking/utils';
import { ProductEventWither } from '@helpers/googleTagManager';

import { getProductsByIdBatched_vpProductByIds } from '../../BatchVPProductQuery/queries/__generated__/getProductsByIdBatched';

export type WishlistActionLocation = 'product_detail' | 'wishlist' | 'list';

export const handleAddToWishlistGTM = (
  product: getProductsByIdBatched_vpProductByIds,
  timing: number,
  actionLocation: WishlistActionLocation,
  additionalPromoLabels: string[] = []
) => {
  dispatchTrackingEvent({
    event: 'add_to_wishlist',
    _clear: true,
    wishlist: {
      action: 'product_added_to_wishlist',
      interaction: 'click_add',
      type: actionLocation,
      timing,
      products: [
        ProductEventWither()
          .withVpProduct(product)
          .withAdditionalPromoLabels(additionalPromoLabels)
          .build(),
      ],
    },
  });
};

export const handleRemoveFromWishlistGTM = (
  product: getProductsByIdBatched_vpProductByIds,
  timing: number,
  actionLocation: WishlistActionLocation
) => {
  dispatchTrackingEvent({
    event: 'remove_from_wishlist',
    _clear: true,
    wishlist: {
      action: 'product_removed_from_wishlist',
      interaction: 'click_remove',
      type: actionLocation,
      timing,
      products: [ProductEventWither().withVpProduct(product).build()],
    },
  });
};
